export default __webpack_public_path__ + "static/media/dieppe17.d79b85b9.jpg";